// JsFromRoutes CacheKey 233b2113e2cb11ae7d7d49dfcb142db4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/customize-gift'),
  showGiftSeries: /* #__PURE__ */ definePathHelper('get', '/customize-gift-series/:gift_series_id'),
  defaultLocation: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/default_location'),
  generalPlaces: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/general_places'),
  giftlyDesigns: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/giftly_designs'),
  giftSeries: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/gift_series'),
  recommendedDesigns: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/recommended_designs'),
  recommendedItems: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/recommended_items'),
  recommendedTaglines: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/recommended_taglines'),
  recommendedTitles: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/recommended_titles'),
  giftTags: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/gift_tags'),
  popularTags: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/popular_tags'),
  searchDesigns: /* #__PURE__ */ definePathHelper('post', '/consumer/customizer/search_designs'),
  searchPlaces: /* #__PURE__ */ definePathHelper('post', '/consumer/customizer/search_places'),
  validateTagline: /* #__PURE__ */ definePathHelper('post', '/consumer/customizer/validate_tagline'),
  createGiftTag: /* #__PURE__ */ definePathHelper('post', '/consumer/customizer/gift_tags'),
  giftlyImage: /* #__PURE__ */ definePathHelper('post', '/consumer/customizer/giftly_image'),
  trackVisit: /* #__PURE__ */ definePathHelper('get', '/consumer/customizer/track_visit'),
  updatePurchasedGift: /* #__PURE__ */ definePathHelper('patch', '/consumer/customizer/purchased_gift/:id'),
}
